// ให้หน้าที่ต้องการพื้นที่เต็มจอ (เช่น กระดานงาน) ขยาย <main> ของ Layout ได้ — หน้าอื่นคง max-w-6xl
import { createContext, useContext, useEffect } from 'react';

export const MainWidthContext = createContext<(full: boolean) => void>(() => undefined);

/** ขยาย <main> เต็มความกว้างขณะ `full` เป็นจริง — ออกจากหน้า/ปิดแล้วคืนค่าเดิมเอง */
export function useFullWidthMain(full: boolean) {
  const setFull = useContext(MainWidthContext);
  useEffect(() => {
    setFull(full);
    return () => setFull(false);
  }, [full, setFull]);
}
